export default {
  ROOT: '/',

  LOGIN: '/login',
  SIGNUP: '/signup',
  TOKEN: '/token',
  IMPLICIT_CALLBACK: '/implicit/callback',
  LOGIN_TROUBLE: '/logintrouble',
  FAQ: '/faq',

  RESET_PASSWORD: '/reset-password',

  COMPLETE_INVITE: '/complete-invite',
  COMPLETE_PROFILE: '/complete-profile',
  REQUEST_ACCESS: '/request-access',

  USERS: '/users',

  BROKERAGES: '/brokerages',
  BROKERAGE: '/brokerage/:brokerageId',
  GET_PDF: '/getPDF',
  CLEARANCE: '/clearance',
  PASS_CLEARANCE: '/passclearance',
  FAIL_CLEARANCE: '/failclearance',

  SUBMISSIONS: '/submissions',
  SUBMISSION: '/submission/:id?',
  SUBMISSION_LEGACY: '/form/:id',

  QUOTE: '/quote/:id?',
  QUOTE_LEGACY: '/formResults/:id',

  ZIGIZONE: '/zigizone',

  LOGIN_CALLBACK: '/login/callback',
  LOGOUT: '/logout',
}
